import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cc-mapping-item',
  templateUrl: './mapping-item.component.html',
  styleUrls: ['./mapping-item.component.scss']
})
export class MappingItemComponent implements OnInit {
  @Input() callerType: string;
  @Input() classState: string;
  @Input() iconUrl: string;
  @Input() title: string;
  @Output() changeCallerType: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  selectType(type) {
    this.changeCallerType.emit(type);
  }
}
